<template>
  <div
    v-if="state"
    :class="['margin-top-lg laptop:margin-top-0', { 'display-none': !hasRefinements &&  !hasSearchTerm}]"
  >
    <ul
      class="display-inline-flex flex-row flex-wrap"
      style="
        --list-style-type: none;
        --padding-left: 0;
        --margin-top: 0;
        --margin-bottom: calc(var(--spacing-2xs) * -1);
        --margin-right: calc(var(--spacing-sm) * -1);
      "
    >
      <search-refinement-widget @clearSearchQuery="clearSearchQuery" />

      <li
        v-for="item in currentRefinements"
        :key="item.attribute"
      >
        <span class="sr-only">{{ item.label }}:</span>

        <ul
          class="display-inline-flex flex-row flex-wrap"
          style="--list-style-type: none; --padding-left: 0; --margin-top: 0; --margin-bottom: 0"
        >
          <li
            v-for="refinement in item.refinements"
            v-show="refinement.attribute !== 'icon_collections'"
            :key="[refinement.attribute, refinement.type, refinement.value, refinement.operator].join(':')"
            class="margin-bottom-2xs margin-right-sm"
          >
            <a
              class="icon-facet-pill tag secondary rounded"
              style="
                --link-decoration-style: none;
                --link-decoration-line: none;
                --link-hover-decoration-style: none;
                --link-hover-decoration-line: none;
                --tag-padding: var(--spacing-sm) var(--spacing-md);
              "
              href="#"
              @click.prevent="removeRefinement(item, refinement)"
            >
              {{ displayRefinement(refinement) }}
              <font-awesome-icon
                :icon="$v6.solid.faXmark"
                fixed-width
                class="icon-facet-pill-affordance margin-left-4xs"
              />
            </a>
          </li>
        </ul>
      </li>

      <clear-widget
        :has-refinements="hasRefinements"
        @clearSearchQuery="clearSearchQuery"
      />
    </ul>
  </div>
</template>

<script>
  import ClearWidget from './ClearWidget'
  import SearchRefinementWidget from './SearchRefinementWidget'
  import { createWidgetMixin } from 'vue-instantsearch'
  import { connectCurrentRefinements } from 'instantsearch.js/es/connectors'

  const categoryIcons = require('app/views/icons/category-figures/v6.json')
  const categoryIcons5 = require('app/views/icons/category-figures/v5.json')

  export default {
    name: 'CurrentFacets',

    components: {
      ClearWidget,
      SearchRefinementWidget
    },

    mixins: [createWidgetMixin({ connector: connectCurrentRefinements })],

    props: {
      hasSearchTerm: {
        type: Boolean,
        required: true
      }
    },

    computed: {
      activeVersion() {
        return this.$releases.active.versionParts.major
      },
      currentRefinements() {
        return this.state.items
      },
      clearRefine() {
        return this.state.refine
      },
      hasRefinements() {
        // exclude icon_collections from the refinement count
        const hasRefinements = this.currentRefinements.filter((refinement) => refinement.attribute !== 'icon_collections').length > 0
        return hasRefinements
      },
      currentIconAssets() {
        if (this.activeVersion === 5) {
          return categoryIcons5
        } else {
          return categoryIcons
        }
      }
    },

    methods: {
      displayRefinement(refinement) {
        switch (refinement.attribute) {
          case 'is_new_in_v6':
            return 'New in v6'
          case 'is_free':
            return 'Free'
          case 'is_staff_favorite':
            return 'Staff Favorites'
          case 'is_sponsored':
            return 'Sponsored'
          case 'style':
            return refinement.label
          case 'family':
            return refinement.label
          case 'icon_packs':
            return `Icon Pack: ${refinement.label}`
          case 'visual_tags':
            return `Type: ${refinement.label}`
          case 'icon_collections':
            return '' // don't display icon_collections refinement
          default:
            return this.categoryLabel(refinement.label)
        }
      },

      categoryLabel(categoryId) {
        const category = this.currentIconAssets.filter((c) => {
          return c.id == categoryId
        })[0]

        return category.label
      },

      clearSearchQuery() {
        this.$emit('clearSearch', '')
      },

      removeRefinement(item, refinement) {
        item.refine(refinement)
        this.$emit('removeRefinement', refinement.attribute)
      }
    }
  }
</script>
